import React, { Fragment } from 'react';
import Link from 'redux-first-router-link';
import PropTypes from 'prop-types';
import OutboundLink from '../common/OutboundLink';
import Separator from '../common/Separator';

const CorpLinks = ({
  isMobile,
}) => {
  const CorpLinkAbout = <Link key="about" className="corp-link" to={{ type: 'ABOUT' }} target="_blank">About</Link>;
  const CorpLinkContact = <Link key="contact" className="corp-link" to={{ type: 'CONTACT' }} target="_blank">Contact</Link>;
  const CorpLinkCareers = <OutboundLink key="careers" className="corp-link" href="https://www.gallerymediagroup.com/careers/one37pm" target="_blank">Careers</OutboundLink>;
  const CorpLinkContributor = <Link key="contributor" className="corp-link contributor" to={{ type: 'CONTRIBUTE' }} target="_blank">Become a Contributor</Link>;
  const CorpLinkConditions = <OutboundLink key="terms" href="https://d3d127vhjgkwcw.cloudfront.net/sales/ONE37pm_Terms_and_Conditions.pdf" className="corp-link" target="_blank">Terms &amp; Conditions</OutboundLink>;
  const CorpLinkPrivacy = <OutboundLink key="privacy" href="https://d3d127vhjgkwcw.cloudfront.net/sales/ONE37pm_Privacy_Policy.pdf" className="corp-link" target="_blank">Privacy Policy</OutboundLink>;
  const CorpLinkEditorial = <OutboundLink key="editorial" href="https://d3d127vhjgkwcw.cloudfront.net/sales/EDITORIAL_POLICY.pdf" className="corp-link" target="_blank">Editorial Policy</OutboundLink>;

  const corpLinks = [
    CorpLinkAbout,
    CorpLinkContact,
    CorpLinkCareers,
    CorpLinkContributor,
    CorpLinkConditions,
    CorpLinkPrivacy,
    CorpLinkEditorial,
  ];

  let renderedCorpLinks = [];

  if (isMobile) {
    renderedCorpLinks = corpLinks.reduce((arr, link, i) => [...arr, link, <Separator key={i} className="corp-link-separator" content="/" />], []);
  }

  if (!isMobile) {
    renderedCorpLinks = [
      [
        CorpLinkAbout,
        CorpLinkContact,
        CorpLinkCareers,
        CorpLinkContributor,
      ],
      [
        CorpLinkConditions,
        CorpLinkPrivacy,
        CorpLinkEditorial,
      ],
    ];
  }


  return (
    <ul className="corp-links">
      {isMobile
        && <Fragment>
          {renderedCorpLinks}
        </Fragment>
      }

      {/* using OutboundLink for styling purposes. Switch to Link to connect to router */}
      {!isMobile
        && <Fragment>
          <div className="corp-links-content">
            <h5 className="corp-links-content-hed">Company</h5>
            {renderedCorpLinks[0]}
          </div>

          <div className="corp-links-content">
            <h5 className="corp-links-content-hed">Legal</h5>
            {renderedCorpLinks[1]}
          </div>
        </Fragment>
      }
    </ul>
  );
};

CorpLinks.propTypes = {
  isMobile: PropTypes.bool,
};

export default CorpLinks;
